/*
*
* File JS componente Icon Text
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Autoplay, A11y]);


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//
import './icon-text.scss';

//--------------------------------------------------------------------//

const iconText = () => {
    let iconTextList = document.querySelectorAll('.icon-text .swiper-container');
    if(!iconTextList.length) return;
    
    iconTextList.forEach(el => {
        let pagination = el.querySelector('.swiper-pagination');

        let args = {
            spaceBetween: 12,
            speed: 600,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                  },
                768: {
                  slidesPerView: 1.8,
                },
                0: {
                  slidesPerView: 1.2,
                },
              },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(el, args);
    })
}

export default iconText;
